module.exports = __webpack_public_path__ + "static/media/venetian06.2bce054b.png";